import { addYears } from 'date-fns';
export const IsInPreviousEntitlementYear = (selectedDate, userEntitlementEndDate) => {
    const endOfLastHolidayYear = addYears(userEntitlementEndDate, -1);
    return selectedDate < endOfLastHolidayYear;
};
